<template>
  <div>
    <el-button type="danger"
               size="small"
               @click="toload">导入</el-button>
    <el-dialog title="人员导入"
               :visible.sync="isStuLead"
               :closeOnClickModal="false"
               class="stuLead"
               width="576px">
      <el-form ref="form"
               :model="form"
               label-width="82px">
        <el-form-item label="项目名称：">
          <el-select v-model="form.name"
                     placeholder="请选择"
                     style="width: 390px;">
            <el-option v-for="item in form.nameList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="importItem">
          <el-form-item label="导入学员："
                        style="margin-bottom:0">
            <UploadExcel :on-success="uploadSuccess"></UploadExcel>
            <span v-show="form.userList.length==0"
                  style="font-size:12px;">已上传{{form.userList.length}}人（上限{{numpeopleMax}}人）</span>
            <span v-show="form.userList.length<=numpeopleMax&&form.userList.length>0"
                  style="font-size:12px;color:green">已上传{{form.userList.length}}人（上限{{numpeopleMax}}人）</span>
            <span v-show="form.userList.length>numpeopleMax"
                  style="font-size:12px;color:red">已上传{{form.userList.length}}人（上限{{numpeopleMax}}人）</span>
          </el-form-item>
          <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #0B8586;cursor: pointer;line-height: 40px;"
                @click="DownloadTemplate">人员导入模板下载</span>
        </div>
        <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: red;line-height: 14px;">注：导入学员未注册全科医学网，用通用密码qkyx123456登录</span>
        <el-form-item>
          <div class="xzbtn"
               @click="toDown"
               v-loading="daorutext=='导入中'">{{daorutext}}</div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="'上传人员信息'+(StuLeadInfoErrNum>0?'（存在'+StuLeadInfoErrNum+'条不合规数据）':'')"
               :visible.sync="isStuLeadInfo"
               class="StuLeadResults"
               width="880px">
      <el-table :data="stuLeadInfoList"
                height="450px"
                :row-class-name="tableRowClassName"
                style="width: 100%">
        <el-table-column label="姓名"
                         width="80">
          <template slot-scope="scope">
            <span v-if="stuLeadInfoIndex!=scope.$index">{{ scope.row.userName }}</span>
            <input v-if="stuLeadInfoIndex==scope.$index"
                   placeholder="请输入姓名"
                   v-myfocus="scope.row.hint.indexOf('姓名') !=-1"
                   style="width:100%"
                   v-model="scope.row.userName" />
          </template>
        </el-table-column>
        <el-table-column label="手机号"
                         width="130">
          <template slot-scope="scope">
            <span v-if="stuLeadInfoIndex!=scope.$index">{{ scope.row.mobile }}</span>
            <input v-if="stuLeadInfoIndex==scope.$index"
                   placeholder="请输入手机号"
                   v-myfocus="scope.row.hint.indexOf('手机号') !=-1"
                   style="width:100%"
                   v-model="scope.row.mobile" />
          </template>
        </el-table-column>
        <el-table-column label="身份证号"
                         width="180">
          <template slot-scope="scope">
            <span v-if="stuLeadInfoIndex!=scope.$index">{{ scope.row.iDcard }}</span>
            <input v-if="stuLeadInfoIndex==scope.$index"
                   placeholder="请输入身份证号"
                   v-myfocus="scope.row.hint.indexOf('身份证号') !=-1"
                   style="width:100%"
                   v-model="scope.row.iDcard" />
          </template>
        </el-table-column>
        <el-table-column label="单位">
          <template slot-scope="scope">
            <span v-if="stuLeadInfoIndex!=scope.$index">{{ scope.row.unit }}</span>
            <input v-if="stuLeadInfoIndex==scope.$index"
                   placeholder="请输入单位"
                   v-myfocus="scope.row.hint.indexOf('单位') !=-1"
                   style="width:100%"
                   v-model="scope.row.unit" />
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span style="color:red">{{ scope.row.hint }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="100px">
          <template slot-scope="scope">
            <el-button size="mini"
                       @click="handleEdit(scope.$index, scope.row)">{{stuLeadInfoIndex==scope.$index?'保存':'修改'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="stuLeadInfoBtn">
        <div class="xzbtn"
             style="color:#000;background:#fff"
             @click="isStuLeadInfo=false">上一步</div>
        <div class="xzbtn"
             @click="submitForm">导入</div>
      </div>
    </el-dialog>
    <el-dialog :title="ResultsTitle+'完成'"
               :visible.sync="isStuLeadResults"
               class="StuLeadResults"
               width="576px">
      <div class="SLRTitle">
        <div :style="isSLR?'background-color: #fff;':''"
             @click="isSLR=true">查看{{ResultsTitle}}成功人员信息（<span :style="isSLRList1.length>0?'color:green':''">{{isSLRList1.length}}</span>）</div>
        <div :style="!isSLR?'background-color: #fff;':''"
             @click="isSLR=false">查看{{ResultsTitle}}失败人员信息（<span :style="isSLRList2.length>0?'color:red':''">{{isSLRList2.length}}</span>）</div>
      </div>
      <el-table :data="isSLR?isSLRList1:isSLRList2"
                height="459"
                style="width: 100%">
        <el-table-column prop="userName"
                         label="姓名"
                         width="80">
        </el-table-column>
        <el-table-column prop="mobile"
                         label="电话"
                         width="120">
        </el-table-column>
        <el-table-column prop="unit"
                         label="单位">
        </el-table-column>
        <el-table-column prop="hint"
                         label="备注">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import UploadExcel from '../../views/components/UploadExcel/index.vue';
export default {
  components: {
    UploadExcel
  },
  data () {
    return {
      uid: 0,
      orgid: 0,
      form: {
        name: '',
        nameList: [],
        userList: []
      },
      isStuLead: false,
      numpeopleMax: '',
      daorutext: '下一步',
      stuLeadInfoIndex: -1,
      isStuLeadInfo: false,
      StuLeadInfoErrNum: 0,
      stuLeadInfoList: [],
      ResultsTitle: '',
      isStuLeadResults: false,
      isSLR: true,
      isSLRList1: [],
      isSLRList2: []
    };
  },
  props: {
    cid: {
      type: String,
      default: ''
    }
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id);
    }
    this.orgid = Number(localStorage.getItem('storeId'))
    this.getCourseList()
    this.getStoreDetail()
  },
  methods: {
    getCourseList () {
      this.httphelper
        .get('/api/LearnProjectApi/GetOrgLearProjectList', {
          orgId: this.orgid,
          type: 2
        })
        .then(res => {
          if (res.code == 200) {
            console.log(res.data);
            this.form.nameList = []
            for (let i = 0; i < res.data.length; i++) {
              this.form.nameList.push({
                value: res.data[i].cid,
                label: res.data[i].pname
              })
            }
          }
        })
    },
    getStoreDetail () {
      this.httphelper.get('/api/CGPEnterPriseApi/GetGpOrganInfoById', {
        id: this.orgid
      })
        .then(res => {
          if (res.code == 200) {
            this.numpeopleMax = res.data.numpeopleMax
          }
        });
    },
    uploadSuccess ({ results }) {
      //   console.log(results);
      // 如果是导入用户
      const userRelations = {
        '姓名': 'userName',
        '手机号': 'mobile',
        '身份证号': 'iDcard',
        '单位': 'unit'
      }
      const arr = []
      results.forEach((item, index) => {
        const userInfo = {}
        item.hasOwnProperty('姓名') == true ? '' : item['姓名'] = "";
        item.hasOwnProperty('手机号') == true ? '' : item['手机号'] = "";
        item.hasOwnProperty('身份证号') == true ? '' : item['身份证号'] = "";
        item.hasOwnProperty('单位') == true ? '' : item['单位'] = "";
        Object.keys(item).forEach(key => {
          if (userRelations[key] == undefined) {
            return this.$message.error('当前Excel表的表头格式不符，建议下载模板使用');
          }
          userInfo[userRelations[key]] = item[key].toString()
        })
        arr.push(userInfo)
      })
      if (arr.length == 0) {
        this.$message.error('当前Excel表中没有数据或表头格式不符，建议下载模板使用');
      } else if (arr.length > this.numpeopleMax) {
        this.$message.error('当前机构人数上限为' + this.numpeopleMax + '人，请勿超过上限');
      } else {
        this.form.userList = arr
        this.$message.success('文件上传成功请点击下一步');
      }
    },
    submitForm () {
      if (this.stuLeadInfoIndex != -1) return this.$message.error('有数据正在修改，请保存后导入！');
      if (this.StuLeadInfoErrNum > 0) return this.$message.error('存在不合规数据，请修正后导入！');
      this.isStuLeadInfo = false
      if (this.daorutext == '导入中') return this.$message.error('导入中');
      this.daorutext = '导入中'
      let arr = []
      for (let i = 0; i < this.stuLeadInfoList.length; i++) {
        arr.push({
          userName: this.stuLeadInfoList[i].userName,
          mobile: this.stuLeadInfoList[i].mobile,
          iDcard: this.stuLeadInfoList[i].iDcard,
          unit: this.stuLeadInfoList[i].unit,
        })
      }
      this.httphelper.post('/api/LearnProjectApi/LearnProjectToLead', {
        cid: this.form.name,
        userlist: arr,
        userId: this.uid,
        orgId: this.orgid
      })
        .then(res => {
          if (res.data.code == 200) {
            this.daorutext = '下一步'
            this.form.userList = ''
            this.isSLRList1 = res.data.data.succlist
            this.isSLRList2 = res.data.data.trylist
            this.ResultsTitle = '导入'
            this.isStuLead = false
            this.isStuLeadResults = true
            this.$emit('toLoadSucces')
          }
        });
    },
    toload () {
      for (let i = 0; i < this.form.nameList.length; i++) {
        if (this.cid == this.form.nameList[i].value) {
          this.isStuLead = true
        }
      }
      if (this.isStuLead == false) {
        this.$message.error('该项目已截止，无法导入');
      }
    },
    toDown () {
      if (this.form.name === '') return this.$message.error('请选择项目');
      if (this.form.userList.length == 0) return this.$message.error('请上传人员');
      this.stuLeadInfoList = []
      this.StuLeadInfoErrNum = 0
      let reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      let reg2 = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      for (let i = 0; i < this.form.userList.length; i++) {
        let hint = ''
        if (this.form.userList[i].userName == '') hint = hint + '姓名不能为空；'
        if (this.form.userList[i].mobile == '') hint = hint + '手机号不能为空；'
        if (this.form.userList[i].iDcard == '') hint = hint + '身份证不能为空；'
        if (!reg.test(this.form.userList[i].mobile) && this.form.userList[i].mobile != '') hint = hint + '手机号格式错误；'
        if (!reg2.test(this.form.userList[i].iDcard) && this.form.userList[i].iDcard != '') hint = hint + '身份证格式错误；'
        if (this.form.userList[i].unit == '') hint = hint + '单位不能为空；'
        if (hint != '') this.StuLeadInfoErrNum++
        this.stuLeadInfoList.push({
          userName: this.form.userList[i].userName,
          mobile: this.form.userList[i].mobile,
          iDcard: this.form.userList[i].iDcard,
          unit: this.form.userList[i].unit,
          hint: hint
        })
      }
      this.isStuLeadInfo = true
    },
    DownloadTemplate () {
      var elink = document.createElement("a");
      elink.download = "人员导入模板.xls";
      elink.style.display = "none";
      elink.href = "https://cgp-resource.oss-cn-beijing.aliyuncs.com/templatefile/toleadtemplate.xlsx";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      //   const headers = {
      //     '姓名': 'userName',
      //     '手机号': 'mobile',
      //     '身份证号': 'iDcard',
      //     '单位': 'unit'
      //   }
      //   import('@/assets/unit/Export2Excel').then(async excel => {
      //     let res = []
      //     const data = this.formatJson(headers, res)
      //     excel.export_json_to_excel({
      //       header: Object.keys(headers),
      //       data,
      //       filename: '人员导入模板',
      //       autoWidth: true,
      //       bookType: 'xlsx'
      //     })
      //   })
    },
    formatJson (headers, rows) {
      return rows.map(item => {
        return Object.keys(headers).map(key => {
          return item[headers[key]]
        })
      })
    },
    handleEdit (index, item) {
      if (this.stuLeadInfoIndex == index) {
        let hint = ''
        let reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        let reg2 = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (this.stuLeadInfoList[index].userName == '') hint = hint + '姓名不能为空；'
        if (this.stuLeadInfoList[index].mobile == '') hint = hint + '手机号不能为空；'
        if (this.stuLeadInfoList[index].iDcard == '') hint = hint + '身份证不能为空；'
        if (!reg.test(this.stuLeadInfoList[index].mobile) && this.stuLeadInfoList[index].mobile != '') hint = hint + '手机号格式错误；'
        if (!reg2.test(this.stuLeadInfoList[index].iDcard) && this.stuLeadInfoList[index].iDcard != '') hint = hint + '身份证格式错误；'
        if (this.stuLeadInfoList[index].unit == '') hint = hint + '单位不能为空；'
        this.stuLeadInfoList[index].hint = hint
        this.StuLeadInfoErrNum = 0
        for (let i = 0; i < this.stuLeadInfoList.length; i++) {
          if (this.stuLeadInfoList[i].hint != '') this.StuLeadInfoErrNum++
        }
        this.stuLeadInfoIndex = -1
      } else {
        this.stuLeadInfoIndex = index
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.hint != '') {
        return 'warning-row';
      }
      return '';
    }
  },
};
</script>
<style lang="scss" scoped>
.stuLead ::v-deep .el-dialog {
    padding: 50px 52px;
    height: 362px;
    border-radius: 10px;
}
.stuLead ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.stuLead ::v-deep .el-dialog__header {
    padding: 0;
    margin-bottom: 30px;
}
.stuLead ::v-deep .el-dialog__body {
    padding: 0;
}
.xzbtn {
    margin-top: 25px;
    margin-left: 64px;
    width: 200px;
    height: 40px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.importItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.StuLeadResults ::v-deep .el-dialog {
    padding: 50px 52px;
    height: 660px;
    border-radius: 10px;
}
.StuLeadResults ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.StuLeadResults ::v-deep .el-dialog__header {
    padding: 0;
    margin-bottom: 30px;
}
.StuLeadResults ::v-deep .el-dialog__body {
    padding: 0;
}
.StuLeadResults ::v-deep td {
    padding: 8px 0 !important;
}
.StuLeadResults ::v-deep .cell {
    text-align: center;
}
.StuLeadResults ::v-deep .warning-row {
    background: rgba(255, 55, 55, 0.206);
}
.StuLeadResults ::v-deep.el-table tbody tr:hover > td {
    background-color: unset;
}
.stuLeadInfoBtn {
    width: 100%;
    display: flex;
    justify-content: center;
}
.stuLeadInfoBtn .xzbtn {
    margin-left: 20px;
    margin-right: 20px;
    width: 160px;
    height: 36px;
    line-height: 34px;
    border-radius: 17px;
    border: 1px solid #0b8586;
}
.SLRTitle {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border: 1px solid rgb(226, 226, 226);
    border-bottom: 4px solid rgb(207, 207, 207);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #eee;
}
.SLRTitle div {
    width: 50%;
    text-align: center;
    cursor: pointer;
}
</style>